import React from 'react'
import { Spin } from 'antd'
import Config from '../../../Config'
import { CustomerText } from '../../../CustomerText'
const { Language } = Config()

const tempText = CustomerText[Language]

export default class SpinLoading extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    render() {
        return <Spin
            className={'hide'}
            id="CustomerServiceSpin"
            size="large"
            tip={tempText?.text70}
        />
    }
}